<template>
  <div class="box-container">
    <d-header
      fluid
      :breadcrumbs="false"
      :actions="[
        {
          label: $t('new_owner_contact'),
          resource: 'ownerContact',
          path: 'contacts/create',
          primary: true,
          color: 'is-primary'
        }
      ]"
    >
      <h2 class="title is-5">
        {{ $t("owner_contacts").capitalize() }}
      </h2>
    </d-header>

    <v-owner-contact-list :owner_id="model.id" />
  </div>
</template>

<script>
import list from "./_list.vue";

export default {
  components: {
    "v-owner-contact-list": list
  },
  props: {
    model: {
      default: null,
      type: Object
    }
  },
  metaInfo() {
    return {
      title: this.$t("owner_contacts").capitalize()
    };
  }
};
</script>
